import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=e67d7398&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=e67d7398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67d7398",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarMenu: require('/workspace/components/NavBarMenu.vue').default,UserAvatar: require('/workspace/components/UserAvatar.vue').default,SuperAdminCompanyModal: require('/workspace/components/SuperAdminCompanyModal/SuperAdminCompanyModal.vue').default})
